import { render } from './config'

export default function(layerInfo, options, container, renderer) {
  const renderFunc = render[layerInfo.type]
  if (renderFunc) {
    renderFunc(layerInfo, options, container, renderer)
  } else {
    console.error(`Unhandled render type: ${layerInfo.type}`)
  }
}
